export default __webpack_public_path__ + "c40dd119abf2ae22051531728544f5b0.svg";